export default __webpack_public_path__ + "static/media/3M.01c36567.webp";